import {type CSSProperties} from 'react'

export const inputStyle: CSSProperties = {
  flex: 1,
  background: 'transparent',
  border: 'none',
  outline: 'none',
  fontSize: 15,
  fontWeight: 400,
  color: '#fff',
  lineHeight: '23px',
  minWidth: 0,
}

/**
 * Returns the visual box for input rows. Takes the onboarding tokens so
 * colours track the active theme; layout numbers are frozen per spec.
 */
export function inputRowStyle(tokens: {
  onboarding: {inputBg: string}
}): CSSProperties {
  return {
    backgroundColor: tokens.onboarding.inputBg,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    height: 44,
    padding: '0 12px',
    borderRadius: 10,
  }
}

export function labelStyle(tokens: {
  onboarding: {textMedium: string}
}): CSSProperties {
  return {
    fontSize: 13,
    fontWeight: 500,
    lineHeight: '17px',
    color: tokens.onboarding.textMedium,
    display: 'block',
    margin: 0,
  }
}
